export default "__VITE_ASSET__BL5K9RrP__"